import { createStore } from 'vuex';
import state from '@/vue/reviews-translation/store/state/state';

// getters
import getter_getters from '@/vue/reviews-translation/store/getters/getters';

// mutations
import mutation_mutations from '@/vue/reviews-translation/store/mutations/mutations';

// actions
import action_actions from '@/vue/reviews-translation/store/actions/actions';

const store = createStore({
  state: {
    ...state
  },
  getters: {
    ...getter_getters
  },
  mutations: {
    ...mutation_mutations
  },
  actions: {
    ...action_actions
  }
});

export const useStore = () => store;

export default store;
